import * as utils from '@/utils/helpers'

const Utils: any = utils

Utils.install = (Vue) => {
    Vue.prototype.$utils = Utils
}

export default Utils
